// =============================================================================
// Home "Browse by topic" — expand/collapse the coverage panel of each card.
// The "+" toggles .is-open on the card; CSS shows the panel and rotates the +.
// =============================================================================

const init = () => {
	document.querySelectorAll('.aa-topic__open').forEach((btn) => {
		btn.addEventListener('click', () => {
			const card = btn.closest('.aa-topic');
			const wasOpen = card.classList.contains('is-open');

			// Accordion — only one panel open at a time.
			document.querySelectorAll('.aa-topic.is-open').forEach((openCard) => {
				openCard.classList.remove('is-open');
				const openBtn = openCard.querySelector('.aa-topic__open');
				if (openBtn) {
					openBtn.setAttribute('aria-expanded', 'false');
				}
			});

			if (!wasOpen) {
				card.classList.add('is-open');
				btn.setAttribute('aria-expanded', 'true');
			}
		});
	});
};

if ('loading' === document.readyState) {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
